import { Box, Typography, LinearProgress, IconButton, CircularProgress } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteIcon from '@mui/icons-material/Delete';
import useUploadDocumentoAssinadoHook from '../../hooks/useUploadDocumentoAssinadoHook';
import './UploadDocumentoAssinado.scss';

export default function UploadDocumentoAssinado({
  onFilesChange,
  arquivosEnviados = [],
  onRemoveServerFile,
  onUploadedFilesChange
}) {
  const {
    inputRef,
    handleInputChange,
    handleClick,
    handleDrop,
    handleDragOver,
    handleDragLeave,
    isDragOver,
    uploadedFiles,
    formatSizeKb,
    handleRemove,
    getStatusText
  } = useUploadDocumentoAssinadoHook({
    onFilesChange,
    arquivosEnviados,
    onRemoveServerFile,
    onUploadedFilesChange
  });

  return (
    <Box className="box-input-upload">
      <input ref={inputRef} type="file" accept=".pdf,.xml,.zip" onChange={handleInputChange} />

      <Box
        component="div"
        onClick={handleClick}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        className={`box-upload-component ${isDragOver ? 'is-drag-over' : ''}`}
      >
        <UploadFileIcon />
        <Typography variant="body2">
          <span className="link-upload">Clique</span>
          &nbsp;ou arraste e solte
        </Typography>

        <Typography variant="caption" color="text.secondary">
          pdf, xml, zip
        </Typography>
      </Box>

      {uploadedFiles.map(item => (
        <Box key={item.id} className="uploaded-file">
          <UploadFileIcon className="uploaded-file__icon" />

          <Box className="uploaded-file__info">
            <Typography className="uploaded-file__name">{item.file.name}</Typography>
            <Typography className="uploaded-file__meta">
              {item.file.size ? formatSizeKb(item.file.size) : ''} • {getStatusText(item.status)}
            </Typography>

            <LinearProgress
              variant="determinate"
              value={item.progress}
              className={`uploaded-file__progress ${item.status === 'error' ? 'error' : ''}`}
            />
          </Box>

          {item.status !== 'loading' && (
            <IconButton className="uploaded-file__delete" onClick={() => handleRemove(item.id)}>
              <DeleteIcon />
            </IconButton>
          )}

          {item.status === 'loading' && (
            <IconButton className="uploaded-file__delete">
              <CircularProgress size={24} />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
}
